import { SET_UF } from './actionTypes';
import { UF } from '@/src/types/uf';

const initialState: UF = {
  _id: '',
  day: 0,
  month: 0,
  year: 0,
  date: '',
  value: 0,
  createdAt: '',
  updatedAt: '',
  deleted: false,
};

const reducer = (state = initialState, { type, payload }: { type: string; payload: UF }) => {
  switch (type) {
    case SET_UF:
      return {
        ...state,
        ...payload,
      };

    default:
      return state;
  }
};

export default reducer;
